<template>
  <div class="container" :style="{width: openType === 'wechat' ? 'calc(100% - env(safe-area-inset-left) - env(safe-area-inset-right))' : '100%'}">
    <div class="header">
      <div @click="$router.replace({path: '/index', query: {ruleToQuestion: $route.query.ruleToQuestion ? 'true': ''}})" class="back"></div>
      <div class="title"></div>
      <div class="logo"></div>
    </div>
    <div class="main">
      <div class="navi">
        <div
          v-for="(item, index) in naviOptions"
          :key="index"
          class="navi-item"
          @click="selectNavi(index)"
          :class="naviIndex === index ? 'navi-item-active' : ''"
        >{{item}}</div>
      </div>
      <div @scroll="scrollLoad()" @touchmove="scrollLoad()" class="content" ref="scrollContainer">
        <div class="inner" ref="inner">
          <div
            v-for="(item, index) in questionGroup"
            :key="item.poetry_id"
            class="item"
            :ref="index == questionGroup.length - 1 ? 'end' : '' "
            @click="getDetail(item.poetry_id, index)"
          >
            <div class="item-title">{{item.title}}</div>
            <div v-if="item.author" class="item-author">({{item.author}})</div>
          </div>
          <div v-if="tips" class="tips">{{tips}}</div>
        </div>
      </div>
    </div>
    <question
      v-if="questionPopup"
      :hasPrevious="hasPrevious"
      :hasNext="hasNext"
      @previous="previous"
      @next="next"
      @close="questionPopup = false"
      :detail="detail"
    ></question>
  </div>
</template>

<script>
import Question from '../components/popup/question'
import Model from '../model'
import Utils from '../util/util'

export default {
  components: {
    Question
  },
  data() {
    return {
      waiting: 2000,
      naviIndex: 0,
      naviOptions: ['小学', '初中', '高中', '课外'],
      questionPopup: false,
      questionGroup: [],
      stage: 0,
      after: 0,
      offset: 30,
      detail: {},
      containerHeight: '',
      throttleScrollLoad: null,
      tips: '',
      currentIndex: '',
      hasNext: true,
      hasPrevious: false,
      openType: ''
    }
  },
  created() {
    this.getQuestionDetail()
  },
  mounted() {
    this.openType = Utils.getOpenType()
    this.containerHeight = this.$refs.scrollContainer.clientHeight
    this.throttleGetQuestionDetail = Utils.throttle(this.getQuestionDetail, this.wait)
  },
  methods: {
    async getQuestionDetail() {
      let questionGroup = this.questionGroup
      const res = await Model.getQuestionGroup({
        stage: this.stage,
        after: this.after,
        offset: this.offset
      })
      if (res.data.records.length == 0) {
        this.tips = '没有更多数据了~'
        return
      }
      questionGroup = questionGroup.concat(res.data.records)
      this.after = questionGroup[questionGroup.length - 1].poetry_id
      this.questionGroup = questionGroup
    },

    async getDetail(poetry_id, index) {
      if (index == 0) {
        this.hasPrevious = false
        this.hasNext = true
      } else if (index == this.questionGroup.length - 1) {
        this.hasPrevious = true
        this.hasNext = false
      } else {
        this.hasPrevious = true
        this.hasNext = true
      }
      
      this.currentIndex = index
      const res = await Model.getPoetryDetail({
        poetry_id
      })
      this.detail = res.data
      this.questionPopup = true
    },

    async previous() {
      if (this.currentIndex == 1) {
        this.hasPrevious = false
        // this.$toast({message: '已经是第一首了~', className: 'toast-trans'})
      } else {
        this.hasPrevious = true
      }
      if (this.currentIndex == 0) {
        this.hasPrevious = false
        return
      }
      this.hasNext = true
      this.currentIndex -= 1
      const res = await Model.getPoetryDetail({
        poetry_id: this.questionGroup[this.currentIndex].poetry_id
      })
      this.detail = res.data
    },

    async next() {
      if (this.currentIndex == this.questionGroup.length - 2) {
        this.hasNext = false
        // this.$toast({message: '已经是最后一首了~', className: 'toast-trans'})
      } else {
        this.hasNext = true
      }
      if (this.currentIndex == this.questionGroup.length - 1) {
        this.hasNext = false
        return
      }
      this.hasPrevious = true
      this.currentIndex += 1
      const res = await Model.getPoetryDetail({
        poetry_id: this.questionGroup[this.currentIndex].poetry_id
      })
      this.detail = res.data
    },

    async selectNavi(index) {
      this.hasNext = true,
      this.hasPrevious = false
      this.stage = index
      this.tips = ''
      this.questionGroup = []
      this.after = 0
      this.getQuestionDetail()
      this.naviIndex = index
    },

    scrollLoad() {
      const innerHeight = this.$refs.inner.offsetHeight
      const scrollTop = this.$refs.scrollContainer.scrollTop
      const top = this.$refs.scrollContainer.offsetTop
      if (innerHeight - (scrollTop + top + this.containerHeight)  < 3) {
        if (this.tips === '没有更多数据了~') {
          return
        } else {
          this.throttleGetQuestionDetail()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@function px2rem($px) {
  $rem: 375px;
  @return ($px/$rem) + rem;
}

.container {
  padding: px2rem(16px) px2rem(28px) 0;
  box-sizing: border-box;
  font-size: px2rem(16px);

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;

    .back {
      width: px2rem(21px);
      height: px2rem(30px);
      background: url("https://image.co-study.com.cn/web/answer-game/back.png");
      background-size: 100% 100%;
    }

    .title {
      width: px2rem(100px);
      height: px2rem(42px);
      line-height: px2rem(42px);
      background: url("https://image.co-study.com.cn/web/answer-game/questions-title.png");
      background-size: 100% 100%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }

    .logo {
      width: px2rem(72px);
      height: px2rem(46px);
      background: url("https://image.co-study.com.cn/web/answer-game/logo.png");
      background-size: 100% 100%;
    }
  }

  .main {
    display: flex;
    justify-content: space-between;
    margin: px2rem(30px) px2rem(10px) 0 px2rem(10px);

    .navi-item {
      width: px2rem(78px);
      height: px2rem(30px);
      line-height: px2rem(30px);
      background: url("https://image.co-study.com.cn/web/answer-game/navi-bg.png");
      background-size: 100% 100%;
      font-size: px2rem(16px);
      text-align: center;
      color: #f4f1ec;
      margin-bottom: px2rem(4px);
    }

    .navi-item-active {
      background: url("https://image.co-study.com.cn/web/answer-game/navi-bg-s.png") !important;
      background-size: 100% 100% !important;
      color: #534831 !important;
    }

    .content::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }

    .content {
      // width: px2rem(506px);
      height: px2rem(230px);
      transform: translateX(px2rem(36px));
      overflow: scroll;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE 10+ */

      .inner {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;

        .tips {
          width: calc(100% - 15px);
          color: #534831;
          font-size: px2rem(12px);
          text-align: center;
        }

        .item {
          width: px2rem(114px);
          height: px2rem(38px);
          background: url("https://image.co-study.com.cn/web/answer-game/item-bg.png");
          background-size: 100% 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-right: px2rem(10px);
          margin-bottom: px2rem(10px);

          .item-title {
            width: px2rem(110px);
            font-size: px2rem(10px);
            line-height: px2rem(12px);
            color: #534831;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            text-align: center;
          }

          .item-author {
            font-size: px2rem(10px);
            color: #b96c35;
            transform: scale(0.8, 0.8);
            -webkit-transform: scale(0.8, 0.8);
          }
        }
      }
    }
  }
}
</style>